const AssetSelectionSkeletonRow = ({ indent = 0 }: { indent?: number }) => (
  <div className="flex h-6 justify-between gap-3 animate-pulse">
    <div className="bg-ds-natural-50 w-6 rounded-md" />
    <div className="bg-ds-natural-50 grow rounded-md" />
  </div>
);

export interface AssetSelectionSkeletonProps {
  count?: number;
}

export const AssetSelectionSkeleton = ({
  count = 4,
}: AssetSelectionSkeletonProps) => {
  return (
    <div className="flex flex-col gap-9 p-2">
      {Array.from(Array(count)).map((_, index) => (
        <AssetSelectionSkeletonRow key={index} />
      ))}
    </div>
  );
};
